function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
export var TokenBucket = /*#__PURE__*/ function() {
    "use strict";
    function TokenBucket(capacity, fillTokensPerSecond) {
        _classCallCheck(this, TokenBucket);
        /**
   * The last time refilled in milliseconds.
   * https://developer.mozilla.org/en-US/docs/Web/API/DOMHighResTimeStamp
   */ this.lastFilled = null;
        this.capacity = capacity;
        if (fillTokensPerSecond === undefined) {
            this.fillTokensPerSecond = capacity;
        } else {
            this.fillTokensPerSecond = fillTokensPerSecond;
        }
        // The bucket starts out filled.
        this.tokens = capacity;
    }
    var _proto = TokenBucket.prototype;
    // Refills tokens according to the fillRate.
    _proto.refill = function refill() {
        if (this.lastFilled !== null) {
            var elapsedMs = TokenBucket.getTimeMs() - this.lastFilled;
            var tokensToAdd = elapsedMs / 1000 * this.fillTokensPerSecond;
            this.tokens = Math.min(this.tokens + tokensToAdd, this.capacity);
        }
        this.lastFilled = TokenBucket.getTimeMs();
    };
    /**
   * If the bucket has enough tokens, removes the specified number
   * and returns true. Otherwise returns false.
   */ _proto.removeToken = function removeToken() {
        var tokensToRemove = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        this.refill();
        if (this.tokens >= tokensToRemove) {
            this.tokens -= tokensToRemove;
            return true;
        }
        return false;
    };
    TokenBucket.getTimeMs = function getTimeMs() {
        return window.performance.now();
    };
    _createClass(TokenBucket, [
        {
            key: "numWholeTokens",
            get: // Number of whole tokens.
            function get() {
                return Math.floor(this.numTokens);
            }
        },
        {
            key: "numTokens",
            get: function get() {
                this.refill();
                return this.tokens;
            }
        }
    ]);
    return TokenBucket;
}();
